import { Injectable } from '@angular/core';
import { FeedbackReportReceipt } from '../../domain/models/feedback-report.model';
import { FeedbackReportReceiptDto } from '../dtos/feedback-report.dto';

@Injectable()
export class FeedbackReportMapper {
  public toDomain(dto: FeedbackReportReceiptDto): FeedbackReportReceipt {
    return {
      publicId: dto?.PublicId ?? '',
      createdAtUtc: dto?.CreatedAtUtc ?? '',
    };
  }
}
